import ModelProxy, {required, optional} from './proxy';
import RxHistory from './rx-history';

export default class Patient extends ModelProxy {

  static propTypes = {
    id: optional,
    uuid: required,
    pseudoName: required,
    region: required,
    isChild: required,
    treatments: required
  };

  static defaultProps = {
    isChild: false
  };

  static setTreatments(self, value) {
    self.props.treatments = value.map(v => (
      v instanceof RxHistory ?
        v : new RxHistory(v)
    ));
  }

}



// WEBPACK FOOTER //
// ./src/models/patient.js